import React, { useState, useEffect, useRef } from "react";

import TextField from "@material-ui/core/TextField";
import InputAdornment from '@material-ui/core/InputAdornment';
import EditIcon from '@material-ui/icons/Edit';
import useKeypress from "./UseKeyPress/UseKeyPress";
import useOnClickOutside from "./UseOnClickOutside/UseOnClickOutside";

import classes from "./InlineEdit.module.css";

function InlineEdit(props) {
  const [isInputActive, setIsInputActive] = useState(false);
  const [inputValue, setInputValue] = useState(props.text);

  const wrapperRef = useRef(null);
  const textRef = useRef(null);
  const inputRef = useRef(null);

  const enter = useKeypress("Enter");
  const esc = useKeypress("Escape");
  
  // check to see if the user clicked outside of this component
  useOnClickOutside(wrapperRef, () => {
    if (isInputActive) {
      props.onSetText(inputValue);
      setIsInputActive(false);
    }
  });

  useEffect(() => {
    setInputValue(props.text);
  }, [props.text]);

  // focus the cursor in the input field on edit start
  useEffect(() => {
    if (isInputActive) {
      inputRef.current.focus();
    }
  }, [isInputActive]);

  useEffect(() => {
    if (isInputActive) {
      // if Enter is pressed, save the text and case the editor
      if (enter) {
        props.onSetText(inputValue);
        setIsInputActive(false);
      }
      // if Escape is pressed, revert the text and close the editor
      if (esc) {
        setInputValue(props.text);
        setIsInputActive(false);
      }
    }
  }, [enter, esc, inputValue, isInputActive, props]); // watch the Enter and Escape key presses

  return (
    <span className="inline-text" ref={wrapperRef}>
      <TextField
        ref={textRef}
        onClick={() => setIsInputActive(true)}
        className={
          !isInputActive
            ? classes.inlineTextCopyActive
            : classes.inlineTextCopyHidden
        }
        value={props.text}
        variant="outlined"
        //id="outlined-multiline-flexible"
        multiline
        rowsMax={4}
        label={props.label}
        color="primary"
        InputLabelProps={{
          shrink: true,
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="start">
              <EditIcon fontSize="small" color="primary" />
            </InputAdornment>
          ),
        }}
      />
      <TextField
        inputRef={inputRef}
        variant="outlined"
        //id="outlined-multiline-flexible"
        multiline
        rowsMax={4}
        label={props.label}
        color="primary"
        InputLabelProps={{
          shrink: true,
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="start">
              <EditIcon fontSize="small" color="primary" />
            </InputAdornment>
          ),
        }}
        // set the width to the input length multiplied by the x height
        // it's not quite right but gets it close
        // style={{ width: Math.ceil(inputValue.length * 0.9) + "ex" }}
        value={inputValue}
        onChange={(e) => {
          setInputValue(e.target.value);
        }}
        className={
          isInputActive
            ? classes.inlineTextInputActive
            : classes.inlineTextInputHidden
        }
      />
    </span>
  );
}

export default InlineEdit;
